module.exports = __webpack_public_path__ + "static/icon_opendota-a1f62f93858125084831b4c3addbed3b.png";